<template>
  <v-sheet
    elevation="2"
    class="mx-4 my-4 mb-2 rounded-lg"
    style="cursor: pointer"
    @click="detail()"
  >
    <v-container>
      <v-row>
        <v-col>
          <div class="mt-1">
            <v-icon>mdi-account</v-icon> {{ user.firstname }}
            {{ user.lastname }} | {{ user.school }} -
            {{ user.year }}
          </div>
          <div>
            <v-icon>mdi-calendar</v-icon> Date d'inscription:
            {{ inscriptionDate }}
          </div>
          <div><v-icon>mdi-tie</v-icon> Role: {{ role }}</div>
        </v-col>
        <v-col cols="auto" class="d-flex align-center">
          <v-hover v-slot="{ hover }">
            <v-btn
              @click.stop="deleteUser()"
              class="role-btn3 d-flex align-center"
              id="btn1"
            >
              <v-icon class="transition-icon"> mdi-delete </v-icon>
              <transition name="fade">
                <span v-if="hover" class="role-text ml-2"> Supprimer </span>
              </transition>
            </v-btn>
          </v-hover>

          <v-hover v-slot="{ hover }">
            <v-btn
              @click.stop="swapTeacher()"
              class="role-btn1 d-flex align-center"
            >
              <v-icon class="transition-icon">
                {{ user.is_teacher ? "mdi-school" : "mdi-school-outline" }}
              </v-icon>
              <transition name="fade">
                <span v-if="hover" class="role-text ml-2">
                  {{ user.is_teacher ? "Enlever tuteur" : "Passer tuteur" }}
                </span>
              </transition>
            </v-btn>
          </v-hover>
          <v-hover v-slot="{ hover }">
            <v-btn
              @click.stop="swapAdmin()"
              class="role-btn2 d-flex align-center"
              id="btn1"
            >
              <v-icon class="transition-icon">
                {{
                  user.is_admin
                    ? "mdi-shield-crown"
                    : "mdi-shield-crown-outline"
                }}
              </v-icon>
              <transition name="fade">
                <span v-if="hover" class="role-text ml-2">
                  {{
                    user.is_admin
                      ? "Enlever administrateur"
                      : "Passer administrateur"
                  }}
                </span>
              </transition>
            </v-btn>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "CardMember",
  props: {
    user: Object,
  },
  methods: {
    detail: function () {
      this.$router.push("member/" + this.user._id);
    },
    swapTeacher: function () {
      let payload = {
        _id: this.user._id,
        is_teacher: !this.user.is_teacher,
      };

      this.$store.dispatch("admin/modifyUser", payload);
    },
    swapAdmin: function () {
      this.$swal.fire({
        title: `Rentrez le code de verification`,
        input: "number",
        confirmButtonText: "Valider",
        showCancelButton: true,
        cancelButtonText: "Retour",
        showLoaderOnConfirm: true,
        preConfirm: async (code) => {
          let payload = {
            _id: this.user._id,
            is_admin: !this.user.is_admin,
            code: code,
          };
          try {
            await this.$store.dispatch("admin/modifyUser", payload);
            return true;
          } catch (error) {
            this.$swal.showValidationMessage(error.error);
          }
        },
      });
    },
    deleteUser() {
      this.$swal
        .fire({
          title: `Êtes-vous sûr de vouloir supprimer cet utilisateur ?`,
          icon: "warning",
          html: `Supprimer cet utilisateur entraînera la désactivation de son accès au site web.<br>Pour réactiver le compte, veuillez contacter le chargé IT.`,
          confirmButtonText: "Supprimer",
          confirmButtonColor: "#d33",
          showCancelButton: true,
          cancelButtonText: "Annuler",
        })
        .then((result) => {
          if (result.isConfirmed)
            this.$store.dispatch("admin/deleteUser", this.user._id);
        });
    },
  },
  computed: {
    inscriptionDate: function () {
      return dayjs(this.user.created_at).format("DD/MM/YYYY HH:mm");
    },
    role: function () {
      if (this.user.is_admin) {
        return "Administrateur";
      } else if (this.user.is_teacher) {
        return "Tuteur";
      } else {
        return "Etudiant";
      }
    },
  },
};
</script>

<style scoped>
.role-btn1,
.role-btn2 {
  margin-left: 10px;
}
.role-btn1 {
  overflow: hidden;
  transition: width 0.3s ease;
  width: 40px;
}
.role-btn1:hover {
  width: 190px;
}
.role-btn2 {
  overflow: hidden;
  transition: width 0.3s ease;
  width: 40px;
}
.role-btn2:hover {
  width: 260px;
}
.role-btn3 {
  overflow: hidden;
  transition: width 0.3s ease;
  width: 40px;
}
.role-btn3:hover {
  width: 150px;
  color: red;
}
.transition-icon {
  transition: transform 0.3s ease;
}
.icon-shifted {
  transform: translateX(-10px);
}
.role-text {
  white-space: nowrap;
}
</style>
